import React from "react";
import { useTranslation } from "react-i18next";

export function ScrollIndicator() {
  const { t, i18n } = useTranslation();
  return (
    <div
      className="flex flex-col items-center gap-3 text-[var(--paper-100)]/70 select-none"
      data-testid="scroll-indicator"
      aria-hidden="true"
    >
      <span className="text-[10px] tracking-[0.3em] uppercase font-mono-brand">
        {i18n.language?.startsWith("en") ? "SCROLL" : t("hero.scroll")}
      </span>
      <div className="relative w-[1px] h-10 bg-white/15 overflow-hidden">
        <span
          className="absolute left-1/2 -translate-x-1/2 top-0 w-[3px] h-[10px] rounded-full"
          style={{
            background:
              "linear-gradient(180deg, rgba(240,196,90,1) 0%, rgba(212,175,55,0) 100%)",
            animation: "scrollDot 2.6s ease-in-out infinite",
          }}
        />
      </div>
    </div>
  );
}
